export const createCustomEvent = (message: string, detail?: unknown) => {
  return new CustomEvent(message, { bubbles: true, detail })
}
